import React, { Component } from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import AsResponsiveContent from '../airship-wrappers/AsResponsiveContent';
import AsLegendCategory from '../airship-wrappers/AsLegendCategory';
import DpsCategoryWidget from '../DpsCategoryWidget';
import DpsLayerToggle from '../DpsLayerToggle';
import DpsLegendColorContinuousPolygon from '../DpsLegendColorContinuousPolygon'
import DpsLegendCategory from '../DpsLegendCategory';
import DpsActiveFilters from '../DpsActiveFilters';
import * as layers from '../../layers';
import DpsQueryModifier from '../DpsQueryModifier';
import DpsLegendSizeContinuousPoint from '../DpsLegendSizeContinuousPoint';
import { MAP_CONFIG } from '../../MAP_CONFIG';
import { withCarto } from '../../carto/withCarto';
import DpsLoadingIndicator from '../DpsLoadingIndicator';

export class Property extends Component {
  state = {
    ready: false,
    parcelCost: undefined,
    parcelContent: undefined,
    parcelCount: undefined,
    dataviewLoading: false,
    isLoadingParcels: true,
  }

  selectedLayers = ['parcel', 'parcelCount', 'parcelCost', 'parcelContent']

  constructor(props) {
    super(props)
    this.categoryWidget = React.createRef()
  }

  componentDidMount() {
    this.props.CartoContext.initCarto()
  }

  componentWillUnmount() {
    if (this.state.ready) {
      this.props.CartoContext.dataviews['parcelCount'].off('dataChanged', this.updateCount)
      this.props.CartoContext.dataviews['parcelCost'].off('dataChanged', this.updateCost)
      this.props.CartoContext.dataviews['parcelContent'].off('dataChanged', this.updateContent)
      this.props.CartoContext.resetLayers()
    }
  }

  onReady = () => {
    this.props.CartoContext.loadMap(MAP_CONFIG)
    this.props.CartoContext.loadLayers([
      {...layers.wildfire, hide: true},
      {...layers.flood, hide: true},
      {...layers.damInundation, hide: true},
      {...layers.landslide, hide: true},
      {...layers.tsunami, hide: true},
      {...layers.levee, hide: true},
      {...layers.eq1, hide: true},
      {...layers.eq2, hide: true},
      {...layers.slr, hide: true},
      {...layers.parcel, index: 7, callback: this.mapLoaded},
      layers.municipality,
      layers.kernCounty,
    ])
    this.props.CartoContext.loadDataview(layers.parcelCategories)
    this.props.CartoContext.loadDataview(layers.parcelCount)
    this.props.CartoContext.loadDataview(layers.parcelCost)
    this.props.CartoContext.loadDataview(layers.parcelContent)
    this.props.CartoContext.dataviews['parcelCount'].on('dataChanged', this.updateCount)
    this.props.CartoContext.dataviews['parcelCost'].on('dataChanged', this.updateCost)
    this.props.CartoContext.dataviews['parcelContent'].on('dataChanged', this.updateContent)
    this.props.CartoContext.addPopup('parcel', 'featureClicked', this.popupContent)

    this.props.CartoContext.addToMap()
    this.setState(state => ({ ...state, ready: true }))
  }

  mapLoaded = (loaded) => {
    this.setState(state => ({
      ...state,
      isLoadingParcels: loaded !== 'loaded'
    }))
  }

  popupContent = (vars) => (`
    <div style="max-height: 200px; overflow: scroll;">${
          [
            {
              label: 'Municipality',
              value: vars.mun,
            },
            {
              label: 'Cost',
              value: '$'+numeral(vars.cost*1000).format('0,0'),
            },
            {
              label: 'Wildfire Risk Area',
              value: vars.haz_wf,
            },
            {
              label: 'M6.8 Concord Green Valley',
              value: vars.haz_eq1,
            },
            {
              label: 'M7.1 Hayward Rodgers Creek',
              value: vars.haz_eq2,
            },
            {
              label: 'FEMA Flood Zone Area',
              value: vars.haz_fld,
            },
            // {
            //   label: 'FEMA Flood Sub Type Area',
            //   value: vars.haz_fldsub,
            // },
            {
              label: 'Dam Inundation Area',
              value: vars.haz_damg,
            },
            {
              label: 'Tsunami Runup Area',
              value: vars.haz_tsu,
            },
            {
              label: 'Landslide Risk Area (High)',
              value: vars.haz_ls,
            },
            {
              label: 'Area Protected by Levee',
              value: vars.haz_lev,
            },
            {
              label: 'Sea Level Rise Inundation (scenario level - low rise to extreme rise)',
              value: vars.haz_slr
            },
          ].map(field => (
            `<small style="opacity: 0.67;">${field.label}</small>
            <p style="margin-top: 0px;" class="description open-sans">${field.value}</p>`
          )).join('')
        }</div>
  `)

  updateCount = (data) => {
    this.setState(state => ({
      ...state,
      parcelCount:  data.result,
    }))
  }

  updateCost = (data) => {
    this.setState(state => ({
      ...state,
      parcelCost:  data.result,
    }))
  }

  updateContent = (data) => {
    this.setState(state => ({
      ...state,
      parcelContent:  data.result,
    }))
  }

  clearFilters = () => {
    this.categoryWidget.current.clearSelection()
    this.selectedLayers.forEach(layer => {
      this.props.CartoContext.clearFilters(layer)
    })
  }

  render() {
    return (
      <AsResponsiveContent onReady={this.onReady}>
        <DpsLoadingIndicator isLoading={this.state.isLoadingParcels}></DpsLoadingIndicator>
        <aside className="as-sidebar as-sidebar--left" data-name="Jurisdiction">
          <div className="as-container as-p--16">
            {
              this.state.ready && 
              <DpsCategoryWidget ref={this.categoryWidget} dataview="parcelCategories" selectedLayers={this.selectedLayers} heading="Jurisdiction"  field="mun" description="Select parcels in any jurisdictions"></DpsCategoryWidget>
            }
          </div>
        </aside>
        <main className="as-main">
          <div className="as-map-panels" data-name="Layers">
            {this.state.ready && <div className="as-panel as-panel--top as-panel--right">
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <h4 className="as-subheader">Map Hazard Layers</h4>
                <DpsLayerToggle label="Parcel Points" layer="parcel" checked>
                  <as-legend>
                    <DpsLegendSizeContinuousPoint
                        layer="parcel"
                        reducer={(obj) => {
                          let label = obj.key[1] > 0 ? numeral(obj.key[1]*1000).format('0.0a') : 0
                          return { label: label, width: obj.value }
                        }}> 
                    </DpsLegendSizeContinuousPoint>
                    <DpsLegendColorContinuousPolygon layer="parcel" sum={numeral(this.state.parcelCostMax).format('0.0a')}></DpsLegendColorContinuousPolygon>
                  </as-legend>
                </DpsLayerToggle>
                <p>Hazard Layer</p>
                <DpsLayerToggle label="M6.8 Concord Green Valley" layer="eq1" beforeLayerID="parcel">
                  <as-legend description="M6.8 Concord Green Valley">
                    <DpsLegendCategory layer="eq1"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="M7.1 Hayward Rodgers Creek" layer="eq2" beforeLayerID="parcel">
                  <as-legend description="M7.1 Hayward Rodgers Creek">
                    <DpsLegendCategory layer="eq2"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="FEMA Flood Hazard" layer="flood" beforeLayerID="parcel">
                  <as-legend>
                    <DpsLegendCategory layer="flood"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Dam Inundation" layer="damInundation" beforeLayerID="parcel">
                  <as-legend>
                    <AsLegendCategory slot="legends" orientation="vertical" data={[{type: 'point', color: "#81ccb4", label: "Dam Inundation"}]}></AsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Wildfire" layer="wildfire" beforeLayerID="parcel">
                  <as-legend>
                    <DpsLegendCategory layer="wildfire"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Landslide" layer="landslide" beforeLayerID="parcel">
                  <as-legend>
                    <DpsLegendCategory layer="landslide"></DpsLegendCategory>
                  </as-legend>  
                </DpsLayerToggle>
                <DpsLayerToggle label="Tsunami Runup Area" layer="tsunami">
                  <as-legend>
                    <DpsLegendCategory layer="tsunami"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Area Protected by Levee" layer="levee">
                  <as-legend>
                    <DpsLegendCategory layer="levee"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Sea Level Rise (By Scenario of Rise)" layer="slr">
                  <as-legend>
                    <DpsLegendCategory layer="slr"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <p>Base Map</p>
                <DpsLayerToggle label="Solano County" layer="kernCounty" checked beforeLayerID="parcel">
                </DpsLayerToggle>
                <DpsLayerToggle label="Municipality" layer="municipality" checked beforeLayerID="parcel">
                </DpsLayerToggle>
              </div>
            </div>}
          </div>
          <div className="as-map-panels" data-name="Summary">
            {this.state.ready && <div className="as-panel as-panel--top as-panel--left" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <span> Selected Parcel Count</span>
                <br/>
                <span style={{margin: 0, fontSize: '1.5em', fontWeight: 'bold'}}>
                {this.state.parcelCount !== undefined ? numeral(this.state.parcelCount).format('0,0') : 'Loading'}
                </span>
                <br/>
                <span> Selected Parcel Structure Value</span>
                <br/>
                <span style={{margin: 0, fontSize: '1.5em', fontWeight: 'bold'}}>
                {this.state.parcelCost !== undefined ? '$'+numeral(this.state.parcelCost*1000).format('0,0') : 'Loading'}
                </span>
                <br/>
                <span> Selected Parcel Content Value</span>
                <br/>
                <span style={{margin: 0, fontSize: '1.5em', fontWeight: 'bold'}}>
                  {this.state.parcelContent !== undefined ? '$'+numeral(this.state.parcelContent*1000).format('0,0') : 'Loading'}
                </span>
              </div>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <h4 className="as-subheader">Vulnerability Data</h4>
                <p style={{ marginTop: 0 }}>Property Risk Filters</p>
                <DpsQueryModifier label="M6.8 Concord Green Valley" layerNames={this.selectedLayers} field="haz_eq1" values={['Severe', 'Very Strong','Strong']}></DpsQueryModifier>
                <DpsQueryModifier label="M7.1 Hayward Rodgers Creek" layerNames={this.selectedLayers} field="haz_eq2" values={['Severe', 'Very Strong','Strong']}></DpsQueryModifier>
                <DpsQueryModifier label="FEMA Flood Risk" layerNames={this.selectedLayers} field="haz_fld" values={['100yr','100yr Coastal', '500yr', 'PROTECTED BY LEVEE']}></DpsQueryModifier>
                <DpsQueryModifier label="Dam Inundation Risk" layerNames={this.selectedLayers} field="haz_damg" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Wildfire Risk" layerNames={this.selectedLayers} field="haz_wf" values={['Very High', 'High', 'Moderate']}></DpsQueryModifier>
                <DpsQueryModifier label="Landslide Risk" layerNames={this.selectedLayers} field="haz_ls" values={['High', 'Medium', 'Low']}></DpsQueryModifier>
                <DpsQueryModifier label="Tsunami Runup" layerNames={this.selectedLayers} field="haz_tsu" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Area Protected by Levee" layerNames={this.selectedLayers} field="haz_lev" values={['Yes']}></DpsQueryModifier>
                <DpsQueryModifier label="Sea Level Rise (By Scenario of Rise)" layerNames={this.selectedLayers} field="haz_slr" values={['Low','Intermediate Low','Intermediate','Intermediate High','High','Extreme']}></DpsQueryModifier>
              </div>
              <div className="dps-mx-8">
                <DpsActiveFilters selectedLayers={[{layerName: 'parcel', label: 'Selected Parcel Count'}]} minWidth={200}></DpsActiveFilters>
                <button className="as-panel__element as-btn as-btn--complementary" style={{ color: '#FFF', justifyContent: 'center', width: '100%' }} onClick={this.clearFilters}>Clear All Filters</button>
              </div>
            </div>
            }
          </div>
          <div className="as-map-area">
            <div id="map"></div>
          </div>
        </main>
      </AsResponsiveContent >
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(Property));
